import React, { useEffect } from 'react';
import { Intercom, boot } from '@intercom/messenger-js-sdk';
import { useUser } from '@clerk/clerk-react';

const IntercomProvider = ({ children }) => {
  const { user, isLoaded } = useUser();

  useEffect(() => {
    try {
      if (isLoaded && user) {
        // First initialize Intercom
        Intercom({
          app_id: 'jaocoj94',
        });
        
        // Then boot with user data
        boot({
          user_id: user.id,
          name: user.fullName || user.firstName + ' ' + user.lastName,
          email: user.primaryEmailAddress?.emailAddress,
          created_at: Math.floor(user.createdAt.getTime() / 1000), // Convert to Unix timestamp
        });
      } else if (isLoaded && !user) {
        Intercom({
          app_id: 'jaocoj94',
        });
      }
    } catch (error) {
      console.error('Error initializing Intercom:', error);
    }
  }, [user, isLoaded]);

  return <>{children}</>;
};

export default IntercomProvider;
